<template>
  <div>
    <v-card outlined style="width: 100%;">
      <v-card-title
        class="text-uppercase text-subtitle-2 title-card"
        :style="{ 'background-color': item.bgColor, color: item.color }"
      >
        {{ item.name }}
        <v-spacer></v-spacer>
        <div class=" text-subtitle-2 title-card" :style="{ color: item.color }">doanh số</div>
      </v-card-title>
      <div class="pa-4 pb-0">
        <v-row class="text-center ma-0">
          <v-col cols="12">
            <div class="text-h5 font-weight-medium">{{ formatCurrency(caculateTotal(item)) }}</div>
          </v-col>
          <v-col cols="12" class="pb-0">
            <div class="subtitle-2">
              <span class="text-light-blue">{{ average(caculateTotal(item), caculateTotalExpect(item)) }}%</span> của
              {{ formatCurrency(caculateTotalExpect(item)) }}
            </div>
            <div class=" color-char">
              <div
                :style="{
                  width: average(caculateTotal(item), caculateTotalExpect(item)) + '%',
                  height: '100%',
                  'background-color': '#9FC5F8',
                  'max-width': '100%'
                }"
              ></div>
            </div>
          </v-col>
          <v-col cols="12" class="py-0">
            <v-tabs v-model="tab">
              <v-tab
                class="pa-0 mx-auto"
                style="min-width: 0px;"
                v-for="(quarterly, index) in item.quarterlyRevenue"
                :key="index"
              >
                <v-row class="ma-0 pa-0">
                  <v-col class="pa-0" cols="12">
                    {{ quarterly.name }}
                  </v-col>
                  <v-col
                    class="pa-0"
                    cols="12"
                    :class="{
                      'text-green': average(quarterly.quarterVal, quarterly.quarterTarget) > 100,
                      'text-red':
                        average(quarterly.quarterVal, quarterly.quarterTarget) <= 100 &&
                        0 < average(quarterly.quarterVal, quarterly.quarterTarget)
                    }"
                    style="font-size: 16px;"
                  >
                    {{ average(quarterly.quarterVal, caculateTotalExpect(item)) }}%
                  </v-col>
                </v-row>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item v-for="(quarterly, index) in item.quarterlyRevenue" :key="index">
                <v-card class="d-flex mb-6 subtitle-2" outlined flat tile>
                  <div class="pa-2 mr-auto" outlined>{{ formatCurrency(quarterly.quarterVal) }}</div>
                  <div
                    class="pa-2"
                    outlined
                    :class="{
                      'text-green': Number(quarterly.quarterVal / quarterly.quarterTarget) * 100 > 100,
                      'text-red':
                        Number(quarterly.quarterVal / quarterly.quarterTarget) * 100 <= 100 &&
                        0 < Number(quarterly.quarterVal / quarterly.quarterTarget) * 100
                    }"
                  >
                    {{ average(quarterly.quarterVal, quarterly.quarterTarget) }} %
                  </div>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </div>
    </v-card>
  </div>
</template>
<script>
export default {
  props: {
    item: Object
  },
  data() {
    return {
      tab: 3
    }
  },

  computed: {},
  methods: {
    caculateTotal(item) {
      return item.quarterlyRevenue.reduce((acc, cur) => acc + cur.quarterVal, 0)
    },
    caculateTotalExpect(item) {
      return item.quarterlyRevenue.reduce((acc, cur) => acc + cur.quarterTarget, 0)
    },
    formatCurrency(value) {
      return value.toLocaleString('vi-VN', { currency: 'VND' })
    },
    average(i, t) {
      return Math.floor((i / t) * 100)
    }
  },
  watch: {}
}
</script>
<style scoped lang="scss">
.text-green {
  color: #46be8a;
}

.text-light-blue {
  color: #3498db;
}

.title-card {
  color: white;
  white-space: nowrap;
  line-height: 25px;
}

.color-char {
  width: 100%;
  height: 10px;
  background-color: rgb(0, 0, 0, 0.1);
}

.text-red {
  color: red;
}
</style>
